import React, { useState, useEffect, useContext } from 'react';
import { Loader } from 'semantic-ui-react';

import UserContext from '../../../contexts/UserContext';
import AssignedRequestListItem from '../AssignedRequestListItem';
import { getAcceptedRequests } from '../../../services/activities';

import './style.less';

const AssignedRequestList = ({ history, lastUpdated, setLastUpdated }) => {
    const {
        userObject: {
            registrants: { list: listOfResidents, activeRegistrantsIndexes },
        },
    } = useContext(UserContext);

    const residentIds =
        activeRegistrantsIndexes[0] === 'all-users'
            ? listOfResidents
                  .filter((resident) => resident.manager || resident.canSeeFeed)
                  .map((resident) => resident._id)
            : activeRegistrantsIndexes.map((residentIndex) => listOfResidents[residentIndex]._id);
    const [acceptedRequests, setAcceptedRequests] = useState<any>([]);
    const [isLoading, setIsLoading] = useState<boolean>(false);

    useEffect(() => {
        setIsLoading(true);
        setAcceptedRequests([]);
        if (residentIds.length) {
            getAcceptedRequests(residentIds)
                .then(({ requests }) => {
                    setAcceptedRequests([...requests]);
                    setIsLoading(false);
                })
                .catch((er) => console.log('accepted failed'));
        }
        setIsLoading(false);
    }, [JSON.stringify(residentIds), lastUpdated]);

    return (
        <div>
            <div className="my-requests-title">MY REQUESTS</div>
            {isLoading ? (
                <Loader inline="centered" active={isLoading} />
            ) : (
                <div className="my-request">
                    {acceptedRequests.map(
                        ({
                            _id,
                            Status,
                            RequestedTime,
                            Name,
                            RequestType_Icon,
                            RequestSlots,
                            Registrant_FirstName,
                            Registrant_LastName,
                            Registrant_Image,
                        }) => (
                            <div
                                className="activity-container"
                                key={_id}
                                role="link"
                                onClick={() => {
                                    history.push(`/requests/${_id}`);
                                }}
                            >
                                <AssignedRequestListItem
                                    _id={_id}
                                    Status={Status}
                                    RequestedTime={RequestedTime}
                                    Name={Name}
                                    RequestType_Icon={RequestType_Icon}
                                    RequestSlots={RequestSlots}
                                    refreshLists={setLastUpdated}
                                    ResidentName={`${Registrant_FirstName} ${Registrant_LastName}`}
                                    ResidentImage={Registrant_Image}
                                />
                            </div>
                        ),
                    )}
                </div>
            )}
        </div>
    );
};

export default AssignedRequestList;
